import styled, { css } from 'styled-components';

export const Container = styled.div`
  display: flex;
  width: 30rem;
  height: 80vh;
  min-width:300px;
  flex-direction: column;
  ${({ loading }) =>
    loading &&
    css`
    opacity: 0.9;
    pointer-events: none;
  `}
`;
export const Content = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;
  min-width:300px;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
  .search{
    padding: 0;
    height: 2.5rem;
  }
  .back--{
    display: flex;
    align-items: center;
    width: 6rem;
    cursor: pointer;
  }
  .icon--{
    font-size: 2rem;
  }
  .card--Contact{
    display: flex;
    height: 4.5rem;
    flex-direction: row;
    list-style-type: none;
    padding: 0.5em;
    cursor: pointer;
    &:hover{
      background-color: #e8e8e8;
    }
    .avatar--{
      display: flex;
      width:4rem;
      height:3.65rem;
      justify-content: center;
      align-items: center;
    }
    .info--{
      display: flex;
      width: calc(100% - 4rem);
      max-width: calc(100% - 4rem);
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding-left: 0.5rem;
      padding-right: 0.5rem;
      .name{
        display: flex;
        width:  100%;
        height: 50%;
        font-size: 1.2rem;
        font-weight: 500;
        color: black;
        .name--overflow{
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
      .description{
        display: flex;
        width: 100%;
        height: 50%;
        font-size: 1rem;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        border-bottom: 1px solid #eee;
      }
    }
  }
`;
export const AddContact = styled.div`
  display: flex;
  width: 100%;
  height: 4.5rem;
  flex-direction: row;
  align-items: center;
  padding: 0.5em;
  margin-top: 0.5rem;
  border-radius: 6px;
  cursor: pointer;
  &:hover{
    background-color: #e8e8e8;
  }
  > span{
    display: flex;
    height: 3.5rem;
    width: 3.5rem;
    margin-left: 5px;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    background-color: #1D86FF;
    color: #ffffff;
  }
  > div {
    margin-left: 0.75rem;
    font-size: 1rem;
    font-weight: 500;
    color: #495057;
  }
`;
export const Contacts = styled.ul`
  display: flex;
  width: 100%;
  height: 100%;
  margin-top: 4px;
  flex-direction: column;
  overflow-y: auto;
  &::-webkit-scrollbar{
    width: 5px;
    height: 5px;
  }
  &::-webkit-scrollbar-thumb{
    background-color: rgb(0, 0, 0,0.2);
  }
  ${({ selected }) =>
    selected &&
    css`
      opacity: 0.6;
      pointer-events: none;
  `}
`;